// extracted by mini-css-extract-plugin
module.exports = {"spinnerWrap":"Preloader_spinnerWrap__3f-oW","spinner":"Preloader_spinner__MQm5g","sk-rotateplane":"Preloader_sk-rotateplane__17tUV"};